import IComponent from "components/commons/IComponent";
import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import config_zoomto from "./config_zoomto";
import { saveTextualSearchInput } from "store/globalSlice";
import "./ZoomTo.scoped.css";
import geometryTools from "utils/geometryTools";
import UserGroup from "./UserGroup";
import GetArcGISToken from "utils/GetArcGISToken";
import slopeNoFormat from "utils/slopeNoFormat";

const ZoomToLocation = { height: "70px" };
const ZoomToLocation_Padding = { padding: "25px 20px" };
const ZoomToLocation_Margin = { margin: "20px 0px 0px 0px" };
const TextualSearch = { height: "50px", padding: "15px 20px" };
let availTextualList = [];
export default class ClassName extends IComponent {
  constructor(props) {
    super(props);

    if (availTextualList.length === 0) {
      availTextualList =
        UserGroup["Group" + GetArcGISToken.user.userGroup].TextualSearchs;
      availTextualList.splice(6, 0, {
        Text: "UAV",
        mapType: 3,
      });
    }

    let freeTextEmptyState = {};
    availTextualList.forEach(
      (i) => (freeTextEmptyState["freeText " + i.Text] = "")
    );

    this.state = {
      searchInput: {
        // Search Type
        searchCategory: 0,
        // Slope number (dropdown boxes)
        mmf_i: 0,
        mmf_o: 0,
        mmf_c: 0,
        mmf_l: 0,
        // Free text searches
        // Coordinate
        northing: 810000,
        easting: 810000,
        // UAV from and to year
        uav_from: "",
        uav_to: "",
        ...freeTextEmptyState,
        ...props.reduxStore.global.textualSearchInput,
      },
      searchList: availTextualList
        .filter((i) => props.mapType === 3 || i.mapType !== 3)
        .map((i) => i.Text),
    };
  }
  componentDidMount() {}
  componentWillUnmount() {
    this.props.reduxCallProxy(saveTextualSearchInput, this.state.searchInput);
  }
  onChangeHandler(field, value, values) {
    let newState = { ...this.state.searchInput };
    newState[field] = value;
    console.debug(newState);
    this.setState({
      searchInput: newState,
    });
  }
  createMMSSearchBox(searchInfo) {
    let { searchCategory } = this.state.searchInput;
    const validCategories = [0, 8, 14, 17, 18, 21, 22, 26];
    if (!("mmf_i_" + searchCategory in this.state.searchInput)) {
      this.state.searchInput[`mmf_i_${searchCategory}`] = 0;
      this.state.searchInput[`mmf_o_${searchCategory}`] = 0;
      this.state.searchInput[`mmf_c_${searchCategory}`] = 0;
      this.state.searchInput[
        `mmf_l_${searchCategory}`
      ] = validCategories.includes(searchCategory) ? "" : 0;
    }
    return (
      <div>
        <div className="EqualWidthChildren" style={ZoomToLocation_Margin}>
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "mmf_i_" + searchCategory,
                dataType: "dropdown",
                values:
                  config_zoomto.Search_Input_Values["textual_dropdown_02"],
                naText: "District",
                required: true,
              },

              row: this.state.searchInput,
              key: "textual_dropdown_02",
            }}
            onChange={this.onChangeHandler.bind(this)}
          />
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "mmf_o_" + searchCategory,
                dataType: "dropdown",
                values:
                  typeof searchInfo.slopePart2List === "undefined"
                    ? config_zoomto.Search_Input_Values["textual_dropdown_03"]
                    : searchInfo.slopePart2List,
                required: true,
              },

              row: this.state.searchInput,
              key: "textual_dropdown_03",
            }}
            onChange={this.onChangeHandler.bind(this)}
          />
          {(typeof searchInfo.slopePart3List === "undefined" ||
            searchInfo.slopePart3List.length > 0) && (
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "mmf_c_" + searchCategory,
                  dataType: "dropdown",
                  values:
                    typeof searchInfo.slopePart3List === "undefined"
                      ? config_zoomto.Search_Input_Values["textual_dropdown_04"]
                      : searchInfo.slopePart3List,
                  required: true,
                },

                row: this.state.searchInput,
                key: "textual_dropdown_04",
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
          )}
          {typeof searchInfo.slopePart4List !== "undefined" ? (
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "mmf_l_" + searchCategory,
                  dataType: "dropdown",
                  values: searchInfo.slopePart4List,
                  required: true,
                },
                row: this.state.searchInput,
                key: "textual_dropdown_04",
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
          ) : (
            <EditableDatagridCell
              cellInfo={{
                colDef: validCategories.includes(searchCategory)
                  ? {
                      field: "mmf_l_" + searchCategory,
                      dataType: "text",
                      values: [],
                      // hint: "e.g.0", //"Enter Keywords",
                    }
                  : {
                      field: "mmf_l_" + searchCategory,
                      dataType: searchInfo.slopePart4InputType || "number",
                      values: [],
                      defaultValue: 1,
                      hint: "Enter Keywords",
                    },

                row: this.state.searchInput,
                key: "textual_text_01",
              }}
              onEnterKeyPress={() => this.onTextualSearch(true)}
              onChange={this.onChangeHandler.bind(this)}
            />
          )}
          {searchInfo.name === "ENTLI" ? (
            <div
              style={{
                width: `fit-content`,
                margin: `10px`,
              }}
            >
              E
            </div>
          ) : (
            ""
          )}
          <Button
            classes={{ root: "actionBtn" }}
            variant="contained"
            onClick={() => this.onTextualSearch(true)}
            style={{ height: "57.5px" }}
          >
            <span className="icn_menu_search icon_s" />
          </Button>
        </div>
        {!searchInfo.noSlopeTextbox && this.createFreeTextSearchBox(searchInfo)}
      </div>
    );
  }
  createFreeTextSearchBox(searchInfo, isSecond = false) {
    let searchExample = isSecond
      ? searchInfo.searchExample2
      : searchInfo.searchExample;
    return (
      <>
        {searchExample && (
          <div style={ZoomToLocation_Margin}>{searchExample}</div>
        )}
        <div
          className="EqualWidthChildren"
          style={!searchExample ? ZoomToLocation_Margin : {}}
        >
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: `freeText ${searchInfo.name}${isSecond ? "2" : ""}`,
                dataType: "text",
                hint: searchInfo.hint || "",
                materialUiProps:
                  searchInfo.type === "mms" &&
                  {
                    // inputProps: { maxLength: 13 },  // IR-9
                  },
              },
              row: this.state.searchInput,
              key: "textual_text_02",
            }}
            onEnterKeyPress={() => this.onTextualSearch(undefined, isSecond)}
            onChange={this.onChangeHandler.bind(this)}
          />
          <Button
            classes={{ root: "actionBtn" }}
            variant="contained"
            onClick={() => this.onTextualSearch(undefined, isSecond)}
            style={{ height: "58.4px" }}
          >
            <span className="icn_menu_search icon_s" />
          </Button>
        </div>
      </>
    );
  }
  createCoordinateBox() {
    return (
      <div className="EqualWidthChildren" style={{ alignItems: "end" }}>
        <div>
          Easting
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "easting",
                dataType: "number",
                values: [],
                defaultValue: null,
                hint: "(E) no.",
              },

              row: this.state.searchInput,
              key: "textual_co_e",
            }}
            onChange={this.onChangeHandler.bind(this)}
            onEnterKeyPress={() => this.onTextualSearch()}
          />
        </div>
        <div>
          Northing
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "northing",
                dataType: "number",
                values: [],
                defaultValue: null,
                hint: "[N] no.",
              },

              row: this.state.searchInput,
              key: "textual_co_n",
            }}
            onChange={this.onChangeHandler.bind(this)}
            onEnterKeyPress={() => this.onTextualSearch()}
          />
        </div>
        <Button
          classes={{ root: "actionBtn" }}
          variant="contained"
          onClick={() => this.onTextualSearch()}
          style={{ height: "57.5px" }}
        >
          <span className="icn_menu_search icon_s" />
        </Button>
      </div>
    );
  }
  createUAVBox() {
    return (
      <div className="EqualWidthChildren" style={{ alignItems: "end" }}>
        <div>
          From Year
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "uav_from",
                dataType: "dropdown",
                values:
                  config_zoomto.Search_Input_Values[
                    "textual_dropdown_uav_years"
                  ],
                required: true,
              },

              row: this.state.searchInput,
              key: "textual_uav_from",
            }}
            onChange={this.onChangeHandler.bind(this)}
          />
        </div>
        <div>
          To Year
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "uav_to",
                dataType: "dropdown",
                values:
                  config_zoomto.Search_Input_Values[
                    "textual_dropdown_uav_years"
                  ],
                required: true,
              },

              row: this.state.searchInput,
              key: "textual_uav_to",
            }}
            onChange={this.onChangeHandler.bind(this)}
          />
        </div>
        <Button
          classes={{ root: "actionBtn" }}
          variant="contained"
          onClick={() => this.onTextualSearch()}
          style={{ height: "57.5px" }}
        >
          <span className="icn_menu_search icon_s" />
        </Button>
      </div>
    );
  }
  onTextualSearch(slopeDropdown = false, isSecond = false) {
    let value = null;
    let { searchInput, searchList } = this.state;
    let searchTypeIndex = searchInput.searchCategory;
    let searchInfo = this.getSearchInfoObj(searchList[searchTypeIndex]);
    if (isSecond) {
      searchInfo = {
        ...searchInfo,
        fields: searchInfo.fields2,
        searchType: searchInfo.searchType2,
        isNumberFields: searchInfo.isNumberFields2,
      };
    }
    switch (searchInfo.inputType) {
      case "coordinate":
        value = {
          co_e: searchInput.easting,
          co_n: searchInput.northing,
        };
        this.zoomToCoordinate(value);
        return;
      case "uav":
        let { uav_from, uav_to } = searchInput;
        if (uav_from === "" || uav_to === "") break;
        // Because uav_from and uav_to is the index number of year in the dropdown box
        // And the years are in descending order
        if (uav_from < uav_to) {
          this.props.showDialog({
            isOpen: true,
            type: "error",
            title: "Incorrect Search Criteria",
            content: `The "From Year" shouldn't be later than the "To Year"!`,
            onDialogOk: () => {},
          });
          return;
        }
        let currentYear = new Date().getFullYear();
        uav_from = currentYear - uav_from;
        uav_to = currentYear - uav_to;
        value = {
          textual_uav_from: uav_from,
          textual_uav_to: uav_to,
        };
        break;
      case "slopeno":
        if (slopeDropdown) {
          let slopeInput = {
            mmf_i: searchInput[`mmf_i_${searchTypeIndex}`],
            mmf_o: searchInput[`mmf_o_${searchTypeIndex}`],
            mmf_c: searchInput[`mmf_c_${searchTypeIndex}`],
            mmf_l: searchInput[`mmf_l_${searchTypeIndex}`],
          };
          // Use dropdown values
          let { slopePart2List, slopePart3List, slopePart4List } = searchInfo;
          let { mmf_i, mmf_o, mmf_c, mmf_l } = slopeInput;
          mmf_i += 1;
          mmf_o = (slopePart2List ||
            config_zoomto.Search_Input_Values.textual_dropdown_03)[mmf_o];
          mmf_c = (slopePart3List ||
            config_zoomto.Search_Input_Values.textual_dropdown_04)[mmf_c];
          mmf_l = slopePart4List ? slopePart4List[mmf_l] : mmf_l;
          switch (searchInfo.name) {
            case "ENTLI":
              mmf_i = (mmf_i < 10 ? "0" : "") + mmf_i.toString();
              mmf_l = mmf_l.toString();
              mmf_o = mmf_o.replace("-", "");
              mmf_l =
                Array.apply(null, Array(4 - mmf_l.length))
                  .fill(0)
                  .join("") + mmf_l;
              value = `${mmf_i}${mmf_o}${mmf_l}E`;
              break;
            case "LPM Stage 2(H) Study":
              value = `${mmf_i}${mmf_o}/${mmf_c}${mmf_l}`;
              break;
            case "Map Sheet":
              value = `${mmf_i}${mmf_o}-${mmf_c}${mmf_l}`;
              break;
            default:
              value = `${mmf_i}${mmf_o}/${mmf_c} ${mmf_l}`;
              value = slopeNoFormat.FeatureNo13Char(value);
          }
          break;
        }
      default:
        value = this.state.searchInput[
          `freeText ${searchInfo.name}${isSecond ? "2" : ""}`
        ];
        if (
          searchInfo.inputType === "slopeno" &&
          searchInfo.name !== "ENTLI" &&
          searchInfo.name !== "LPM Stage 2(H) Study"
        )
          value = slopeNoFormat.FeatureNo13Char(value);
        break;
    }
    console.debug(searchInfo, value);
    if (!value) this.showMissingInputDialog(searchInfo);
    else this.props.onTextualSearch(searchInfo, value);
  }
  zoomToCoordinate(inputData) {
    let { co_e, co_n } = inputData;
    if (co_e < 800000 || co_e > 860000 || co_n < 800000 || co_n > 860000) {
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Incorrect Search Criteria",
        content: `The coordinate is out of range! the value of each direction should be greater than 800,000 and less than 860,000!`,
        onDialogOk: () => {},
      });
      return;
    }
    let point = new geometryTools.Point({
      type: "point",
      longitude: co_e,
      latitude: co_n,
      spatialReference: { wkid: 102140 },
    });
    geometryTools.refreshGraphicByLayerId(
      this.props.mapView,
      "highlightLayerForMMS",
      point,
      true
    );
    this.props.showDialog({
      isOpen: false,
    });
  }
  getSearchInfoObj(searchName) {
    return config_zoomto.TEXTUAL_SEARCH_LIST.find((i) => i.name === searchName);
  }
  showMissingInputDialog(searchInfo) {
    this.props.showDialog({
      isOpen: true,
      type: "error",
      title: "Missing Search Criteria",
      content: `Search criteria is missing for ${searchInfo.name}!`,
      onDialogOk: () => {},
    });
  }
  render() {
    let searchCategory = this.state.searchInput.searchCategory;
    let searchList = this.state.searchList;
    let searchName = searchList[searchCategory];
    let searchInfo = this.getSearchInfoObj(searchName);
    return (
      <div>
        <div className="SubPanelTitle" style={TextualSearch}>
          Textual Search
        </div>
        <div className="SubPanelContent" style={ZoomToLocation_Padding}>
          <div className="EqualWidthChildren" style={{ margin: "0px" }}>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "searchCategory",
                  dataType: "dropdown",
                  values: searchList,
                  naText: "District",
                  required: true,
                },

                row: this.state.searchInput,
                key: "textual_dropdown_01",
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
          </div>
          {function() {
            let component = null;
            switch (searchInfo.inputType) {
              case "slopeno":
                component = this.createMMSSearchBox(searchInfo);
                break;
              case "coordinate":
                component = this.createCoordinateBox();
                break;
              case "uav":
                component = this.createUAVBox();
                break;
              default:
                component = this.createFreeTextSearchBox(searchInfo);
                break;
            }
            return component;
          }.apply(this)}
          {searchInfo.fields2 && this.createFreeTextSearchBox(searchInfo, true)}
        </div>
      </div>
    );
  }
}
